import { Box, Container, styled } from '@mui/material';
import { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { axiosInstance } from 'src/api/axios';
import FloatingJobPanel from 'src/components/FloatingJobPanel';
import Header from '../full/header/Header';
import Sidebar from './sidebar/AdminSidebar';

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  paddingBottom: '60px',
  flexDirection: 'column',
  zIndex: 1,
  width: 'calc(100vw - 270px)',
  backgroundColor: 'transparent',
}));

const AdminLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  useMemo(() => {
    axiosInstance.get('/users').then((res) => {
      if (res.status < 210) {
        let _ = res.data;
        if (!_?.role.includes('admin')) {
          window.location.href = '/dashboard';
        }
      }
    });
  }, []);
  // const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  return (
    <MainWrapper className="mainwrapper">
      {/* ------------------------------------------- */}
      {/* Sidebar */}
      {/* ------------------------------------------- */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarClose={() => setMobileSidebarOpen(false)}
      />
      {/* ------------------------------------------- */}
      {/* Main Wrapper */}
      {/* ------------------------------------------- */}
      <PageWrapper className="page-wrapper">
        {/* ------------------------------------------- */}
        {/* Header */}
        {/* ------------------------------------------- */}
        <Header
          toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
          toggleMobileSidebar={() => setMobileSidebarOpen(true)}
        />
        {/* ------------------------------------------- */}
        {/* PageContent */}
        {/* ------------------------------------------- */}
        <Container
          sx={{
            paddingTop: '20px',
            maxWidth: '1200px',
          }}
        >
          {/* ------------------------------------------- */}
          {/* Page Route */}
          {/* ------------------------------------------- */}
          <Box sx={{ minHeight: 'calc(100vh - 170px)' }}>
            <Outlet />
          </Box>
          {/* ------------------------------------------- */}
          {/* End Page */}
          {/* ------------------------------------------- */}
        </Container>
      </PageWrapper>
      {/* ------------------------------------------- */}
      {/* Floating Job Panel */}
      {/* ------------------------------------------- */}
      <FloatingJobPanel />
    </MainWrapper>
  );
};

export default AdminLayout;
